import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import api from "../../utils/ApiMethod";
import {
  Box,
  Center,
  Heading,
  Grid,
  Image,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

const GalleryCategoryWise = () => {
  const category1Images = [
    {
      name: "medal-lao-naukri-pao-2026",
      text: "Medal Lao Naukri Pao 2026",
      img: "https://biharsports.org/img/medal-lao-naukri-pao-2026/1.JPG",
      id: "29",
    },
    {
      name: "bssa-summer-camp-2026",
      text: "BSSA Summer Camp 2026",
      img: "https://biharsports.org/img/summer-camp-2026/1.jpeg",
      id: "28",
    },
    {
      name: "esports-2026",
      text: "Esports 2026",
      img: "https://biharsports.org/img/esports-2026/1.jpeg",
      id: "27",
    },
    {
      name: "senior-national-rugby-7s-2026",
      text: "Senior National Rugby 7s 2026",
      img: "https://biharsports.org/img/sen-nat-rug-7/1.jpeg",
      id: "26",
    },
    {
      name: "sub-junior-mens-hockey-2026",
      text: "Sub Junior Mens Hockey 2026",
      img: "https://biharsports.org/img/sub-jun-men-hock/10.jpg",
      id: "25",
    },
    {
      name: "fide-2026",
      text: "FIDE Chess 2026",
      img: "https://biharsports.org/img/fide-2026/1.jpeg",
      id: "24",
    },
    {
      name: "bihar-diwas-2026",
      text: "Bihar Diwas 2026",
      img: "https://biharsports.org/img/bihar-diwas-pavillion/18.jpeg",
      id: "23",
    },
    {
      name: "sports-conclave",
      text: "Sports Conclave",
      img: "https://biharsports.org/img/sports-conclave/1.jpeg",
      id: "22",
    },
    {
      name: "bihar-women-kabaddi-league-edition-2",
      text: "Bihar Women Kabaddi League 2026",
      img: "https://biharsports.org/img/BWKLE2/highlights/10.jpeg",
      id: "21",
    },
    {
      name: "hero-asia-hockey-cup-2025",
      text: "Hero Asia Mens Hockey Cup 2025",
      img: "https://biharsports.org/img/HeroMensHockeyAsiaCup2025Rajgir/highlights/1.jpg",
      id: "20",
    },
    {
      name: "asia-rugby-u20-7s",
      text: "Asia Rugby U20 7s",
      img: "/img/AsiaRugbyU207s/highlights/20.jpg",
      id: "19",
    },
    {
      name: "international-yoga-day-2025",
      text: "International Yoga Day 2025",
      img: "/img/yoga-day-2025/y-1.jpg",
      id: "18",
    },
    {
      name: "Khelo-India-2025-Highlights",
      img: "/img/kiyg25-highlights/badminton/ba-1.jpg",
      id: "17",
    },
    {
      name: "Khelo-India-2025-Launch-Evening",
      img: "/img/kiyg25-evening/launch-1.jpg",
      id: "16",
    },
    {
      name: "Khelo-India-2025-Launch-Morning",
      img: "/img/kiyg25-morning/launch-1.jpg",
      id: "15",
    },
    {
      name: "ISTAF Sepaktakraw World Cup 2025",
      img: "/img/istaf-wc-2025/sepaktakraw-1.jpg",
      id: "14",
    },
    {
      name: "68 National School Games Fencing",
      img: "/img/Fencing/fencing-1.png",
      id: "13",
    },
    {
      name: "Bihar State Open Esports Championship 2024",
      img: "/img/Esports/IMG-20250204-WA0021.jpg",
      id: "12",
    },
    {
      name: "68th National School Game Rugby",
      img: "/img/68thNationalSchoolGameRugby/IMG-20250203-WA0049.jpg",
      id: "11",
    },
    {
      name: "68th National School Games Cycling (Road)",
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0032.jpg",
      id: "10",
    },
    {
      name: "Bihar Women's Asian Champions Trophy Rajgir 2024",
      img: "/img/BWACTRajgir2024/ADIM45653.jpg",
      id: "9",
    },
    {
      name: "Bihar Volleyball League 2024",
      img: "/img/BiharVolleyballLeague2024/DSC00350.jpg",
      id: "8",
    },
    {
      name: "KSS-2023 at Gyan Bhawan",
      img: "/img/KSS-2023/DSC_3832.jpg",
      id: "1",
    },
    {
      name: "1st Bihar State Esports Open Championship",
      img: "/img/1stBiharSEOc/1stbSEoC.jpg",
      id: "2",
    },
    {
      name: "12th National School Chess Championship- 2024",
      img: "/img/12thNS-CHES24/P1383941.jpg",
      id: "3",
    },
    {
      name: "Bihar School Chess at BSSA",
      img: "/img/Bihar-School-Chess/DSC_1538.jpg",
      id: "4",
    },
    {
      name: "Bihar Women Kabaddi League",
      img: "/img/Bihar-Women-Kabaddi-League/JBN00221.jpg",
      id: "5",
    },
    { name: "Conclave 2.0", img: "/img/Conclave2.0/DSC_8220.jpg", id: "6" },
    {
      name: "Dashrath Manjhi",
      img: "/img/DashrathManjhi/DSC_6676.jpg",
      id: "7",
    },
    // { name: "Bihar Women Kabaddi League", img: "/img/Bihar-Women-Kabaddi-League/JBN00221.jpg", id: "8" }
  ];

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Gallery - Bihar State Sports Authority</title>
        <meta
          name="description"
          content="Explore photos and videos of sports events, training sessions, and initiatives by the Bihar State Sports Authority."
        />
      </Helmet>

      <Breadcrumb
        pageName="Gallery"
        pageTitle="gallery"
        id="#gallery"
        img_url="./img/Gallery-desktop.jpg"
        mobile_banner="./img/Gallery-mobile.jpg"
      />
      <Heading p={5} fontSize="50px">
        Photos
      </Heading>

      <div className="container">
        <SimpleGrid columns={[1, 2, 3, 4]} spacing="20px" justifyItems="center">
          {category1Images.map((item, index) => (
            <Box key={index} w="100%" marginTop="15px">
              <Link
                to={`/GalleryCategoryWise/Events/${item.name}`}
                _hover={{ textDecoration: "none" }}
              >
                <Box
                  position="relative"
                  width="100%"
                  paddingBottom="75%" // Creates a 4:3 aspect ratio
                  overflow="hidden"
                >
                  <Image
                    src={item.img}
                    alt={item?.text || item.name}
                    position="absolute"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    transition="transform 0.5s ease"
                    _hover={{ transform: "scale(1.2)" }}
                  />
                </Box>
                <Text
                  textAlign="center"
                  marginTop="10px"
                  style={{ fontSize: "20px", fontWeight: "700" }}
                >
                  {item?.text || item.name}
                </Text>
              </Link>
            </Box>
          ))}
        </SimpleGrid>
      </div>
    </div>
  );
};

export default GalleryCategoryWise;
